<template>
  <div>
    <form @submit.prevent="submit">
      <b-row>
        <b-col sm="12">
          <b-form-group label="Número SIF">
            <b-form-input
              type="text"
              :state="
                $v.inspeccion.sif_number.$dirty
                  ? !$v.inspeccion.sif_number.$error
                  : null
              "
              v-model="$v.inspeccion.sif_number.$model"
              v-on:keyup="inputSoloNumero"
              placeholder=""
            >
            </b-form-input>
          </b-form-group>

          <b-form-group label="Productos">
            <b-form-select
              :state="
                $v.inspeccion.product.$dirty
                  ? !$v.inspeccion.product.$error
                  : null
              "
              v-model="$v.inspeccion.product.$model"
              :options="products"
            >
            </b-form-select>
          </b-form-group>

          <b-form-group label="Planta">
            <b-form-select
              :state="
                $v.inspeccion.plant.$dirty ? !$v.inspeccion.plant.$error : null
              "
              v-model="$v.inspeccion.plant.$model"
              :options="plants"
            >
            </b-form-select>
          </b-form-group>

          <!-- <b-form-group label="País destino">
            <b-form-select
              :state="
                $v.inspeccion.destination_country.$dirty
                  ? !$v.inspeccion.destination_country.$error
                  : null
              "
              v-model="$v.inspeccion.destination_country.$model"
              :options="destination_countrys"
            >
            </b-form-select>
          </b-form-group> -->

          <!-- <b-form-group label="Descripción paises destino">
            <b-form-input
              type="text"
              :state="
                $v.inspeccion.countries.$dirty
                  ? !$v.inspeccion.countries.$error
                  : null
              "
              v-model="$v.inspeccion.countries.$model"
              placeholder="Ej. ALEMANIA-INGLATERRA-UNION EUROPEA-HOLANDA"
            >
            </b-form-input>
          </b-form-group> -->

          <b-form-group label="Destino">
            <b-form-select
              text-field="name"
              value-field="id"
              multiple
              :state="
                $v.inspeccion.destination.$dirty
                  ? !$v.inspeccion.destination.$error
                  : null
              "
              v-model="$v.inspeccion.destination.$model"
              :options="destination_markets"
            >
            </b-form-select>
          </b-form-group>

          <b-form-group label="Fecha SIF">
            <datetime
              type="datetime"
              :state="
                $v.inspeccion.sif_date.$dirty
                  ? !$v.inspeccion.sif_date.$error
                  : null
              "
              v-model="$v.inspeccion.sif_date.$model"
              required
              :minute-step="10"
              aria-describedby="input-inputFechaTermino-live-feedback"
              input-class="form-control"
              class="theme-orange"
            >
            </datetime>
          </b-form-group>

          <b-form-group label="Contraparte SAG">
            <b-form-select
              :state="
                $v.inspeccion.sag_worker.$dirty
                  ? !$v.inspeccion.sag_worker.$error
                  : null
              "
              v-model="$v.inspeccion.sag_worker.$model"
              :options="workers"
            >
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </form>
  </div>
</template>

<script>
import {
  required,
  numeric,
  minLength,
  between
} from "vuelidate/lib/validators";

export default {
  name: "formInspecion",
  props: ["inspeccion"],
  data() {
    return {
      workers: "",

      products: "",
      plants: "",
      destination_countrys: "",
      destination_markets: []
    };
  },
  validations: {
    inspeccion: {
      sif_number: { required, numeric },
      sif_date: { required },
      sag_worker: { required },
      product: { required },
      plant: { required },
      destination: { required }
      // destination_country: { required }
      // countries: { required }
    }
  },
  mounted() {
    this.loadDataForm();
  },
  methods: {
    saveForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return 0;
      } else {
        return 1;
      }
    },
    inputSoloNumero(event) {
      event.target.value = event.target.value.replace(/[^0-9]/, "");
    },
    loadDataForm() {
      this.$axios
        .get("/production/get_client_plants/")
        .then((res) => {
          this.workers = res.data.workers;
          this.workers.unshift({ value: "", text: "Seleccione" });
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.$axios
        .get("/api/comex/destination_market/?no_page")
        .then((res) => {
          this.destination_markets = res.data;
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.$axios
        .get("/api/comex/companyform/get_products/", {
          params: {
            client: this.$store.getters.user.ID_CLIENTE
          }
        })
        .then((res) => {
          this.products = res.data.data;
          this.products.unshift({ value: "", text: "Seleccione" });
        })
        .catch((error) => console.log(errors));

      this.$axios
        .get("/api/comex/companyform/get_plants/", {
          params: {
            client: this.$store.getters.user.ID_CLIENTE
          }
        })
        .then((res) => {
          this.plants = res.data.plants;
          this.plants.unshift({ value: "", text: "Seleccione" });
        })
        .catch((error) => console.log(errors));

      this.$axios
        .get("/api/comex/companyform/get_select_info_shipment/", {
          params: {
            client: this.$store.getters.user.ID_CLIENTE
          }
        })
        .then((res) => {
          this.destination_countrys = res.data.country_list;
          this.destination_countrys.unshift({ value: "", text: "Seleccione" });
        })
        .catch((error) => console.log(errors));
    },
    submit() {}
  },
  beforeMount() {}
};
</script>

<style scoped></style>
